import { SvgIcon } from "@/components/icon"
import linkedIcon from "@/pages/website-landing/components/footer/images/lingedin.png"
import { FC } from "react"

import "./FooterSocialButtons.less"

// Also in the Organization markup (index.html, guidesPlugin.ts: sameAs)
const LINKEDIN_URL = "https://www.linkedin.com/company/easetechltd/"

/** Easetech's one social profile: the LinkedIn hexagon with a "Follow us" line, the whole block a link. */
const FooterSocialButtons: FC = () => {
  return (
    <div className={"soc-buttons-block"}>
      <a className={"soc-link"} href={LINKEDIN_URL} target={"_blank"} rel={"noopener noreferrer"}>
        <span className={"soc-btn"}>
          <SvgIcon type={"footer-soc-btn"} />
          <img src={linkedIcon} alt={""} />
        </span>
        <span className={"soc-label"}>
          <span>{"Follow us"}</span>
          <strong>{"on LinkedIn"}</strong>
        </span>
      </a>
    </div>
  )
}

export default FooterSocialButtons
